module.exports = __webpack_public_path__ + "img/result.8392efff.png";